"use client";
import useAppSetting from "@/Hooks/useAppSetting";
import { LandingSiteTemplateGetDataOutputApiModel } from "@/Apis/ClinicApi";
import classNames from "classnames";
import { FC, ReactNode } from "react";
import { DarkModeToggle } from "./Components";
import Offcanvas from "./Components/Offcanvas";

interface DoccureLayoutProps {
  children?: ReactNode;
  data: LandingSiteTemplateGetDataOutputApiModel;
}

const DoccureLayout: FC<DoccureLayoutProps> = ({ children, data }) => {
  const { menuOpen, menuToggle } = useAppSetting();
  return (
    <>
      <div className="main-wrapper">
        <DarkModeToggle withWrapper />
        {children}
        <Offcanvas data={data} />
      </div>
      <div
        onClick={() => menuToggle()}
        className={classNames("sidebar-overlay", { opened: menuOpen })}
      ></div>
    </>
  );
};

export default DoccureLayout;
